/**
 * O método de pagamento e a categoria do ÚLTIMO lançamento feito no
 * formulário — para o próximo já abrir com eles (pedido dela, 05/10).
 *
 * ── Por tipo ─────────────────────────────────────────────────────────────
 *
 * Gasto e recebimento guardam cada um o seu: o último gasto foi "Mercado no
 * Nubank" e o último recebimento foi "Salário no PIX". Um só par faria o
 * formulário de gasto abrir com a categoria Salário depois de lançar o salário.
 *
 * ── No aparelho, não na conta ────────────────────────────────────────────
 *
 * É preferência de preenchimento, não dado financeiro: fica no `localStorage`.
 * O que sai daqui é só uma SUGESTÃO de id — quem usa confere contra os métodos
 * e as categorias que existem agora. Um id apagado, ou de outra conta que usou
 * o mesmo navegador, simplesmente não casa com nada e é ignorado.
 *
 * Todo acesso em `try`: aba anônima e armazenamento bloqueado lançam, e a
 * falta desta conveniência nunca pode impedir um lançamento.
 */
const CHAVE = 'fintracking.formulario.ultimaEscolha';

export type TipoDeLancamento = 'expense' | 'income';

export interface UltimaEscolha {
  paymentMethod: string;
  /** '' = o último lançamento foi sem categoria. */
  categoryId: string;
}

type Guardado = Partial<Record<TipoDeLancamento, UltimaEscolha>>;

const lerTudo = (): Guardado => {
  try {
    const bruto = JSON.parse(localStorage.getItem(CHAVE) ?? '{}');
    return bruto && typeof bruto === 'object' ? bruto as Guardado : {};
  } catch {
    return {};
  }
};

export const lerUltimaEscolha = (tipo: TipoDeLancamento): UltimaEscolha | null => {
  const e = lerTudo()[tipo];
  if (!e || typeof e.paymentMethod !== 'string' || typeof e.categoryId !== 'string') return null;
  return e;
};

export const guardarUltimaEscolha = (tipo: TipoDeLancamento, escolha: UltimaEscolha): void => {
  try {
    localStorage.setItem(CHAVE, JSON.stringify({ ...lerTudo(), [tipo]: escolha }));
  } catch {
    /* sem armazenamento: o próximo formulário abre como sempre abriu */
  }
};
